import {useMutation} from '@tanstack/react-query';
import {UpdateProjectPatchParams} from '@contentlab/api/project/types';
import projectUpdaters from '@contentlab/api/project/updaters';

export interface UseUpdateProjectOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

type UpdateProjectMutationParams = {
  projectId: string;
  params: UpdateProjectPatchParams;
};

/**
 * Hook for updating a project.
 *
 * @param options - Optional configuration options.
 * @returns A mutation object with methods for triggering the mutation and managing its state.
 */
function useUpdateProject(options: UseUpdateProjectOptions = {}) {
  const {onSuccess, onError} = options;

  return useMutation<void, Error, UpdateProjectMutationParams>({
    mutationFn: ({projectId, params}: UpdateProjectMutationParams) =>
      projectUpdaters.updateProjectPatch(projectId, params),
    onSuccess,
    onError,
  });
}

export default useUpdateProject;
